import { toHeaderCase } from 'js-convert-case'

import { DocArticleType } from 'routes/Docs/types'

// Filter paths if any segment starts with underscore
export function filterPathWithUnderscore(path: string) {
  return !path.split('/').find((x) => x.match(/^(\d+-)?_/))
}

// get path without heading numbers
export function getCleanPath(path: string) {
  return removeUnderscores(removePrefixNumberFromPath(getRawPath(path)))
}

function removeUnderscores(path: string) {
  return path
    .split('/')
    .map((segment) => segment.replace(/^_/g, ''))
    .join('/')
}

// get path without leading dot, index file and extension
// ready to compare with other paths
export function getRawPath(path: string) {
  return path
    .replace('./', '')
    .replace('.mdx', '')
    .replace('.tsx', '')
    .replace(/^index$/, '')
    .replace(/\/index$/, '')
}

export function removePrefixNumberFromPath(path: string) {
  return path
    .split('/')
    .map((segment) => segment.replace(/^[0-9]+-/, ''))
    .join('/')
}

export function getParentPath(path: string) {
  return path.split('/').slice(0, -1).join('/') || undefined
}

export function getTitleFromPath(path: string) {
  return toHeaderCase(path.split('/').pop() || '')
}

export function sortArrayOfArticles(array: DocArticleType[]) {
  return array.sort((a, b) => compareArticlesByPath(a.rawPath, b.rawPath))
}

export function sortArticleChildren(article: DocArticleType): void {
  if (article.children) {
    article.children = sortArrayOfArticles(article.children)
  }
}

export function compareArticlesByPath(a1: string, a2: string) {
  return a1 > a2 ? 1 : a1 < a2 ? -1 : 0
}
